import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { api } from "../../api";
import { formatDate } from '../../utils/formatDate';

function badgeVariant(daysLeft) {
  if (daysLeft < 0) return 'danger';
  if (daysLeft <= 7) return 'danger';
  if (daysLeft <= 30) return 'warning';
  return 'secondary';
}

function daysLeft(dateStr) {
  if (!dateStr) return Infinity;
  const today = new Date(); today.setHours(0,0,0,0);
  const d = new Date(dateStr); d.setHours(0,0,0,0);
  return Math.ceil((d - today) / (1000 * 60 * 60 * 24));
}

export default function WarningsView({ initialThresholdDays = 30 }) {
  const [thresholdDays, setThresholdDays] = useState(initialThresholdDays);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchWarnings = async () => {
    setLoading(true);
    try {
      const [vehRes, empRes] = await Promise.all([
        api.get('/vehicles'),
        api.get('/users/assignable'),
      ]);

      const vehItems = (vehRes.data || [])
        .filter(v => v.inspectionExpires)
        .map(v => ({
          title: `Fordon ${v.regNr}`,
          subtitle: 'Besiktning – utgångsdatum',
          expires: v.inspectionExpires,
          daysLeft: daysLeft(v.inspectionExpires),
        }));

      const empItems = [];
      (empRes.data.users || []).forEach(e => {
        if (e.ssgExpired) {
          empItems.push({
            title: e.firstName,
            subtitle: 'SSG – utgångsdatum',
            expires: e.ssgExpired,
            daysLeft: daysLeft(e.ssgExpired),
          });
        }
        if (e.lkabExpired) {
          empItems.push({
            title: e.firstName,
            subtitle: 'LKAB – utgångsdatum',
            expires: e.lkabExpired,
            daysLeft: daysLeft(e.lkabExpired),
          });
        }
      });
      const all = [...vehItems, ...empItems]
        .filter(x => x.daysLeft <= thresholdDays)
        .sort((a,b) => a.daysLeft - b.daysLeft);

      setItems(all);
    } catch (err) {
      console.error('Kunde inte hämta varningar:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchWarnings(); }, [thresholdDays]);

  return (
    <div className="container mt-4">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h2 className="m-0">Varningar</h2>
        <div className="d-flex gap-2">
          <select
            className="form-select form-select-sm w-auto"
            value={thresholdDays}
            onChange={e => setThresholdDays(parseInt(e.target.value, 10))}
            title="Varning om X dagar kvar"
          >
            <option value={7}>7 dagar</option>
            <option value={30}>30 dagar</option>
            <option value={60}>60 dagar</option>
            <option value={90}>90 dagar</option>
            <option value={180}>180 dagar</option>
            <option value={365}>365 dagar</option>
          </select>
          <Button size="sm" variant="secondary" onClick={fetchWarnings}>Uppdatera</Button>
        </div>
      </div>

      {loading ? (
        <div>Laddar…</div>
      ) : items.length === 0 ? (
        <div className="alert alert-success">Inga saker går ut inom vald period. 👍</div>
      ) : (
        <ul className="list-group">
          {items.map((it, idx) => (
            <li key={idx} className="list-group-item d-flex justify-content-between align-items-center">
              <div>
                <div className="fw-semibold">{it.title}</div>
                <div className="small text-muted">{it.subtitle}</div>
                <div className="small">
                  Går ut: <strong>{formatDate(it.expires)}</strong>
                </div>
              </div>
              <span className={`badge bg-${badgeVariant(it.daysLeft)}`}>
                {it.daysLeft < 0 ? 'UTGÅNGET' : `${it.daysLeft} d kvar`}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
